<template>
    <span>{{ formattedDate }}</span>
</template>

<script setup lang="ts">
    import { EventDate } from "./types";
    import { computed } from "vue";
    import { dateTimesToDaysRange } from "./dateTimeUtils";

    const props = defineProps<{ eventDate: EventDate | null | undefined; timezone: string }>();

    const formattedDate = computed(() => {
        if (!props.eventDate) {
            return "";
        }

        return dateTimesToDaysRange(props.eventDate.startDate, props.eventDate.endDate, props.timezone);
    });
</script>

<style scoped></style>
